import {
  IonIcon,
  IonImg,
  IonItem,
  IonList,
  IonMenu,
  IonMenuToggle,
} from "@ionic/react";

import { useHistory, useLocation } from "react-router-dom";
import {
  calendarOutline,
  calendar,
  peopleOutline,
  people,
  fileTrayFullOutline,
  fileTrayFull,
  logOutOutline,
  logOut,
  gridOutline,
  grid,
  logoWhatsapp,
  peopleCircleOutline,
  peopleCircle,
  globeOutline,
  globe,
} from "ionicons/icons";
import "./Menu.css";
import { useEffect, useState } from "react";
import ModalPacienteForm from "../ModalFormPaciente/ModalFormPaciente";
import { Link, Typography } from "@mui/joy";
import { Column, Row } from "../../basicsComponents/MaterialGridComponents";

const appPages = [
  {
    title: "Inicio",
    url: "/portal/Inicio",
    iosIcon: gridOutline,
    mdIcon: grid,
  },
  {
    title: "Reservar Turno",
    url: "/portal/Reservar turno",
    iosIcon: peopleCircleOutline,
    mdIcon: peopleCircle,
  },
  // {
  //   title: "Horarios Prestadores",
  //   url: "/portal/Horarios",
  //   iosIcon: peopleOutline,
  //   mdIcon: people,
  // },
  {
    title: "Mis Turnos",
    url: "/portal/Turnos",
    iosIcon: calendarOutline,
    mdIcon: calendar,
  },
  {
    title: "Mis Estudios",
    url: "/portal/Estudios",
    iosIcon: fileTrayFullOutline,
    mdIcon: fileTrayFull,
  },
];

const Menu = () => {
  const location = useLocation();
  const [usuario, setUsuario] = useState({});
  const [openModalPaciente, setOpenModalPaciente] = useState(false);

  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir === true) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const history = useHistory();
  useEffect(() => {
    try {
      setUsuario(JSON.parse(sessionStorage.getItem("ppUL")));
    } catch {
      history.push({ pathname: "/ErrorPage" });
    }
  }, []);

  useEffect(() => {
    if (usuario.nombre !== "") {
      if (history.location.state?.justLogin === true) {
        history.location.state = {};
        setOpenModalPaciente(true);
      }
    }
  }, [usuario, history]);

  return (
    <IonMenu
      contentId="main"
      type="overlay"
      style={{ "--background": "#f5f5f5" }}
      className="menu-container"
    >
      <div className="menu-layout">
        <div className="menu-scroll-container">
          <Row
            container
            className="menu-scroll-content"
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#f5f5f5",
            }}
          >
            <Column
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "auto",
                backgroundColor: "#f5f5f5",
              }}
            >
              <IonImg
                src="assets/icon/LOGO-ONNIS1.png"
                style={{ width: "250px", height: "auto" }}
              />
            </Column>

            <div onClick={() => setOpenModalPaciente(true)}>
              <br />
              <Typography
                level="title-md"
                className="encabezado"
                alignItems={"flex-start"}
                sx={{ color: "#6b33b8" }}
              >
                {usuario.apellido}, {usuario.nombre}
              </Typography>
              <Typography
                level="title-md"
                className="encabezado"
                alignItems={"flex-start"}
                sx={{ color: "#6b33b8" }}
              >
                {usuario.email}
              </Typography>
            </div>
            <IonList
              id="inbox-list"
              style={{ marginTop: "7.5px", backgroundColor: "#f5f5f5" }}
            >
              {appPages.map((appPage, index) => {
                return (
                  <IonMenuToggle key={index} autoHide={false}>
                    <IonItem
                      className={
                        location.pathname === appPage.url ? "selected" : ""
                      }
                      routerLink={appPage.url}
                      routerDirection="none"
                      lines="none"
                      detail={false}
                      style={{ "--background": "#f5f5f5" }}
                    >
                      <IonIcon
                        aria-hidden="true"
                        slot="start"
                        ios={appPage.iosIcon}
                        md={appPage.mdIcon}
                      />
                      <Typography
                        sx={{
                          color:
                            location.pathname === appPage.url
                              ? "#6b33b8"
                              : "#000",
                        }}
                        level={
                          location.pathname === appPage.url
                            ? "title-md"
                            : "title-sm"
                        }
                      >
                        {appPage.title.toUpperCase()}
                      </Typography>
                    </IonItem>
                  </IonMenuToggle>
                );
              })}
              <IonItem
                button
                lines="none"
                className="amarillo-sol"
                style={{ "--background": "#f5f5f5" }}
              >
                <IonIcon slot="start" icon={logoWhatsapp} />
                <Typography level={"title-sm"}>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={
                      "https://wa.me/3512613002?text=Hola,%20me%20pon%C3%ADa%20en%20contacto%20para%20registrarme.%20Dejo%20mis%20datos%20a%20continuaci%C3%B3n:%0ADNI%20(sin%20puntos/espacios):%0ANombre%20y%20apellido:%0AFecha%20de%20nacimiento:%0AEmail:%0ACelular:%0AObra%20social%20%E2%80%93%20plan:"
                    }
                  >
                    {`Nuestros Whatsapp`.toUpperCase()}
                  </a>
                </Typography>
                <IonIcon slot="end" ios={globeOutline} md={globe} />
              </IonItem>
              <IonItem
                button
                lines="none"
                routerLink={"/"}
                style={{ "--background": "#f5f5f5" }}
              >
                <IonIcon
                  aria-hidden="true"
                  color="solid"
                  slot="start"
                  ios={logOutOutline}
                  md={logOut}
                />
                <Typography variant="title-sm" color="danger">
                  {`Cerrar Sesion`.toUpperCase()}
                </Typography>
              </IonItem>
            </IonList>
          </Row>
        </div>

        <div className="menu-footer">
          <Row container justifyContent="center" alignItems="center">
            <Column container justifyContent="space-between" alignItems="center">
              <Link
                href="https://www.gacitua.com.ar/"
                rel="Proveedor del servicio noreferrer"
                target="_blank"
              >
                <Typography level="title-lg">
                  <Typography color="neutral"> {"Powered by "}</Typography>
                  <img
                    src={"assets/logoGacitua.png"}
                    alt="logo gacitua y asociados"
                    width={17}
                    height={17}
                  />
                  <Typography> {" Gacitua & Asociados"}</Typography>
                </Typography>
              </Link>
            </Column>
          </Row>
        </div>
      </div>

      <ModalPacienteForm
        openModal={openModalPaciente}
        setOpenModal={setOpenModalPaciente}
        mostrarNotificacion={mostrarNotificacion}
        paciente={usuario}
        setPaciente={setUsuario}
      />
    </IonMenu>
  );
};

export default Menu;
